import type { SVGProps } from 'react';

const WarningIconAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.99988 7.49824V10.8316M9.99988 14.1649H10.0082M8.84598 3.24134L1.9919 15.0802C1.61173 15.7369 1.42165 16.0652 1.44974 16.3347C1.47425 16.5697 1.59739 16.7833 1.78852 16.9222C2.00765 17.0816 2.38704 17.0816 3.14581 17.0816H16.8539C17.6127 17.0816 17.9921 17.0816 18.2112 16.9222C18.4024 16.7833 18.5255 16.5697 18.55 16.3347C18.5781 16.0652 18.388 15.7369 18.0078 15.0802L11.1538 3.24134C10.775 2.58704 10.5856 2.25989 10.3385 2.15001C10.1229 2.05416 9.87684 2.05416 9.66129 2.15001C9.41419 2.25989 9.22478 2.58704 8.84598 3.24134Z"
      stroke="#F79009"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default WarningIconAlert;
